import { registerComponent, handleize } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-submit",
  class PredictiveSearchSubmit extends WYATTElement {
    constructor() {
      super();

      this.redirect = null;
      this.form = this.closest("form");

      this.submitHandler = this.handleSubmit.bind(this);

      this.query = this.querySelector("[data-query]");
    }

    connectedCallback() {
      this.subscribe(
        WYATT.PubSub.events.searchInputChange,
        this.handleSearchInputChange.bind(this),
      );

      this.subscribe(
        WYATT.PubSub.events.redirectFetched,
        this.conditionallSetSearchspringRedirect.bind(this),
      );

      this.subscribe(
        WYATT.PubSub.events.searchInputUnboundChange,
        this.conditionallySetBrandRedirect.bind(this),
      );
    }

    handleSearchInputChange(event) {
      event.preventDefault();

      this.redirect = null;

      const query = event.detail;

      this.query.textContent = `'${query}'`;
    }

    conditionallySetBrandRedirect(event) {
      const query = event.detail;

      if (!query) {
        this.removeRedirect();
        return;
      }

      const handleizedQuery = handleize(query);

      if (WYATT.shopify.brandsWithCollections.includes(handleizedQuery)) {
        this.redirect = `${WYATT.routes.root}collections/${handleizedQuery}`;
        this.setRedirect();
      } else {
        this.removeRedirect();
      }
    }

    conditionallSetSearchspringRedirect(event) {
      event.preventDefault();

      this.redirect = event?.detail?.merchandising?.redirect;

      if (this.redirect) {
        this.setRedirect();
      } else {
        this.removeRedirect();
      }
    }

    setRedirect() {
      this.form.addEventListener("submit", this.submitHandler);
    }

    removeRedirect() {
      this.form.removeEventListener("submit", this.submitHandler);
    }

    handleSubmit(event) {
      event.preventDefault();

      if (this.redirect) {
        window.location.href = this.redirect;
      }
    }
  },
);
